"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentageNormalizer = exports.percentageFormatter = void 0;
const _1 = require(".");
const percentageFormatter = (percentage, options) => {
    if (!isNaN(percentage)) {
        return (percentage / 100).toLocaleString(_1.DEFAULT_LOCALE, Object.assign(Object.assign({}, _1.PERCENTAGE_FORMAT_OPTIONS), options));
    }
    else {
        return '-';
    }
};
exports.percentageFormatter = percentageFormatter;
const percentageNormalizer = (value) => {
    if (parseFloat(value) <= 1) {
        return String(parseFloat(value) * 100);
    }
    else {
        return String(parseFloat(value));
    }
};
exports.percentageNormalizer = percentageNormalizer;
